<template>
  <div class="rpg-pd-5">
    <div class="rpg-pd-5-10 rpg-bd-b rpg-pr-title">
      <span class="rpg-label">{{ project.客户公司 }}-{{ project.项目名称 }}</span>
      <span class="rpg-gray">（当前项目）</span>
    </div>
    <div class="rpg-pd-5-10 rpg-label">
      面试辅导
      <peixun type="25" style="display:inline-block;margin-left:5px;position:relative;top:3px;"></peixun>
    </div>
    <div style="padding:10px">
      <div class="project-detail-content">
        <div class="project-detail-content-title mb10">项目面试流程</div>
        <pre>{{ project.面试流程 || '暂无面试流程' }}</pre>
      </div>
      <div class="project-detail-content">
        <div class="project-detail-content-title mb10">关键面试决策人：</div>
        <div v-if="jue.length > 0">
          <div v-for="(item, index) in jue" :key="`interviewerHr${index}`" class="new-hr-card mb5">
            <div class="new-hr-card-row">
              <span class="label text-btn" style="font-size:18px;" @click="showRadish({ id: item._id })">{{
                item.姓名
              }}</span>
              <div class="content">
                <span class="mr10">{{ item.公司 }}</span> <span class="mr10">{{ item.部门 }}</span>
                <span class="mr10">{{ item.目前职位 }}</span>
              </div>
            </div>
            <div class="new-hr-card-row">
              <span class="label">人选简介：</span>
              <div class="content">
                <pre>{{ item.简介 }}</pre>
              </div>
            </div>
            <div class="new-hr-card-row">
              <span class="label">面试风格：</span>
              <div class="content">
                <pre>{{ item.面试风格 }}</pre>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="project-detail-content">
        <div class="project-detail-content-title mb10">项目面试辅导</div>
        <pre>{{ project.面试辅导 || '暂无面试辅导' }}</pre>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    radish: {
      type: Object,
    },
    project: {
      type: Object,
    },
    onConfirm: {
      type: Function,
      default: function() {},
    },
  },
  data() {
    return {
      jue: [],
    }
  },
  async mounted() {
    if (this.project.关键面试人 && this.project.关键面试人.length > 0) {
      const res = await app.service('radish').findByIds({ ids: this.project.关键面试人 })
      if (res.status == 'success') {
        this.jue = res.data
      }
    } else {
      this.jue = []
    }
  },
  methods: {
    showRadish(opts) {
      window.open(`${window.frontend}/#/radish-detail-blank/${opts.id}`, '_blank')
    },
    openTrainingVideo() {
      app.root.$refs.TrainingVideoDialog.open('面试安排面试辅导')
    },
  },
}
</script>
<style scoped src="../../../project/src/css/newProjectDetail.css"></style>
